import "Layouts/default";

import { buildStars } from 'Functions/rating';
import { updateLazy } from 'Functions/lazy';
import { scrollToEl } from 'Functions/anchor';
import { initTippy } from 'Functions/tippy';

import 'Ui/slider';
import 'Ui/shorten';
import 'Ui/favorite-trigger';

import './catalog-jquery';
import './filter-slider';
import { initializeScrollIndicator } from "Functions/scroll-indicator";
import { filter } from "underscore";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.c-listing-main'), 0)
        })
    }
}

$(window).on('popstate', () => {
    setTimeout(() => {
        scrollToEl(document.querySelector('.c-listing-main'), 0)
    }, 10);
});

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    buildStars();
    attachPaginatorEvents();
    initTippy();

    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing.products').first().find('.products__item').length);
    }
})

buildStars();
attachPaginatorEvents();
initializeScrollIndicator('.js-scroll-indicator-holder', '.js-scroll-indicator-content')
initTippy('.js-product-banner-tooltip', {
    theme: 'banner-tooltip',
    placement: 'top-start',
    arrow: false,
    trigger: 'click',
    popperOptions: {
        modifiers: [{
            name: 'flip',
            options: {
                fallbackPlacements: ['top-end']
            },
        }],
    },
})

if (document.querySelector('.js-product-banner-tooltip')) {
    const tooltips = document.querySelectorAll('.js-product-banner-tooltip')

    for (let i = 0; i < tooltips.length; i++) {
        const tooltip = tooltips[i];

        setTimeout(() => {
            tooltip.classList.add('is-animatable')
        }, 200 * i % 3600);
    }
}

function updateScrollIndicators() {
    for (const scrollIndicatorContentEl of document.querySelectorAll('.js-scroll-indicator-content')) {
        const event = new CustomEvent('customUpdateScroll')

        scrollIndicatorContentEl.dispatchEvent(event)
    }
}

if (document.querySelector('r-toggle#filter-holder')) {
    const filterHolder = document.querySelector('r-toggle#filter-holder')

    filterHolder.addEventListener('rToggle.afterOpen', updateScrollIndicators)
}

if (document.querySelector('r-tabs.c-filter-tabs')) {
    const filterTabsHolder = document.querySelector('r-tabs.c-filter-tabs')

    filterTabsHolder.addEventListener('rTab.after.openTab', updateScrollIndicators)
}